import { render, staticRenderFns } from "./playBox.vue?vue&type=template&id=221d0fd1&scoped=true&"
import script from "./playBox.vue?vue&type=script&lang=js&"
export * from "./playBox.vue?vue&type=script&lang=js&"
import style0 from "./playBox.vue?vue&type=style&index=0&id=221d0fd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221d0fd1",
  null
  
)

export default component.exports